import { Button, Badge, Card, CardBody, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import NotesSection from './NotesSection';

export default function SubmissionConfirm({ fundRequest }: any) {
    const lastUpdated = moment(fundRequest?.updated_date).format('MM/DD/YY');

    return (
        <div>
            <div className='mb-4'>
                <h1 className='h2'>Submission {fundRequest?.id} Confirmed</h1>
                <div className='d-flex align-items-center flex-wrap'>
                    <Badge color={`none`} className={`badge-submitted me-3`}>
                        Submitted
                    </Badge>
                    <span className='text-muted me-3'>
                        Request ID <span className='fw-bold'>{fundRequest.id}</span>
                    </span>
                    <span className='text-muted'>Last Updated {lastUpdated}</span>
                </div>

                <Row>
                    <Col lg={8}>
                        <Card
                            className='mt-4'
                            style={{
                                background: '#E5F7F7',
                                border: 'none',
                            }}
                        >
                            <CardBody>
                                <p className='mt-3 mb-3'>
                                    Your fund request is submitted and will be reviewed by Help Hope Live. You can follow the status of your request here: <Link to="/requests" style={{ color: '#00a0b0', textDecoration: 'none' }}>Go to Requests</Link>. We will notify you via the Message Center on your Dashboard if additional information is required.
                                </p>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg={4}>
                        <Card className='mt-4' style={{ background: '#ffffff', boxShadow: '0 8px 20px rgba(0,0,0,0.08)', borderRadius: 12 }}>
                            <CardBody>
                                <NotesSection />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            
            <div className='sticky-bottom'>
                <Link to='/requests'>
                    <Button
                        color='link'
                        className='p-0 text-uppercase fw-bold'
                        style={{ color: '#00a0b0', textDecoration: 'none' }}
                    >
                        Return to Requests
                    </Button>
                </Link>
            </div>
        </div>
    );
}
